import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'


export class DoubleImage extends React.PureComponent<DoubleImage.Props, DoubleImage.State> {
    public static sectionId = 'doubleImage';

    public buildItem(block: DoubleImage.Block, i: number) {
      return (
        <a key={i} className="w-full relative" href={block.settings.cta_url}>
          <div className={`relative max-w-[715px] max-h-[715px] ${block.settings.show_cta_underneath ? "underneath-true" : 'underneath-false' } `}>
            { block.settings.image ? 
              <img
                src={block.settings.image }
                alt="Background"
                className="w-full h-full object-cover"
              /> : null
            }
      
            <div className={`absolute inset-0 flex flex-col justify-${block.settings.content_position} items-center text-white py-2`}>
            
              { block.settings.heading ? 
                <Snippets.Heading
                  size={block.settings.heading_style as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' }
                  tag={block.settings.heading_style as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' }
                  className={`leading-none mb-1-6 text-center ${block.settings.content_colour == 'dark' ? 'text-black': 'text-white'} ${block.settings.heading_text_style == 'uppercase' ? 'uppercase': 'lowercase'} ${block.settings.heading_font_style == 'bold' ? 'font-bold' : block.settings.heading_font_style == 'light' ? 'font-light' : 'font-normal'}`}
                >
                  {block.settings.heading}
                </Snippets.Heading>
                : null }

              {block.settings.text ? 
                <p className={`${block.settings.text_width == 'normal' ? 'w-10/12' : 'w-1/2' } ${block.settings.content_colour == 'dark' ? 'text-black': 'text-white'} mx-auto mb-1-6 text-center`}>{block.settings.text}</p>
                : null }
                
              {block.settings.cta_text && block.settings.cta_url && !block.settings.show_cta_underneath ? 
                <a
                  className={` text-center  ${block.settings.button_colour == 'dark' ? 'text-black' :  'text-white'} ${block.settings.button_style == 'button' ? 'border py-1 px-2': 'underline'} ${block.settings.button_style == 'button' && block.settings.button_colour == 'dark' ? 'border-black py-1 px-2': block.settings.button_style == 'button' && block.settings.button_colour == 'white' ? 'border-white' : null}`}
                  href={block.settings.cta_url}
                >
                  {block.settings.cta_text}
                </a>
                : null }
            </div>
          </div>
          { block.settings.show_cta_underneath ?
            <div className={`relative cta_underneath-wrapper py-1-6 px-1-2 flex justify-${block.settings.content_position}`}>
              {block.settings.cta_text && block.settings.cta_url ? 
                <a
                  className={` text-center inline-block  ${block.settings.button_colour == 'dark' ? 'text-black' :  'text-white'} ${block.settings.button_style == 'button' ? 'border py-1 px-2': 'underline'} ${block.settings.button_style == 'button' && block.settings.button_colour == 'dark' ? 'border-black py-1 px-2': block.settings.button_style == 'button' && block.settings.button_colour == 'white' ? 'border-white' : null}`}
                  href={block.settings.cta_url}
                >
                  {block.settings.cta_text}
                </a>
                : null }
            </div> 
            : null}
        </a>
      )
    }
      
      

    public render(): JSX.Element {
      const { settings, blocks } = this.props.section
      const { section } = this.props.data

      // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
      let allow_full_width_images = section?.article?.settings?.allow_full_width_images
      if (!settings) {
        return <React.Fragment/>
      }

      return (
   
        <div className={`double-image__container ${settings.full_width ? 'fullwidth-true': 'fullwidth-false'} ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
          <div className="flex justify-center w-full flex-col md:flex-row gap-2-4">
            {blocks ? (
              blocks.map((block: any, i: number) => this.buildItem(block, i))
            ) : ( 
              []
            )}
          </div> 
        </div>

      )
    }
}

export namespace DoubleImage { 
    export type Options = ShopifyNext.Section<{
    full_width: boolean;
    }>;
    export type Block = {
    settings: {
        image: string;
        content_position: string;
        heading: string;
        text: string;
        text_width: string;
        cta_text: string;
        cta_url: string;
        content_colour: string;
        heading_style: string;
        heading_font_style: string;
        button_style: string;
        button_colour: string;
        heading_text_style: string;
        show_cta_underneath: boolean;
    }
    }
    export type Blocks = Block[]
    export interface Props extends GlobalProps {
    section: DoubleImage.Options;
    blocks: DoubleImage.Blocks;
    }
    export interface State {}
}
